type ChatMessageStatus = "success" | "failure" | null

// Older Mareczek replies were prompted to begin with a standalone H1 of
// "SUCCESS"/"FAILURE". That marker is dropped from the prompt now, but messages
// already stored carry it — strip a leading standalone marker and surface it as
// a status (failure drives the red border). New, unmarked replies pass through
// untouched with a null status.
const LEADING_STATUS_RE = /^\s*#{1,6}[ \t]*(SUCCESS|FAILURE)\b[ \t]*\r?\n?/i

export function parseStatusMarker(text: string): {
	status: ChatMessageStatus
	body: string
} {
	const match = text.match(LEADING_STATUS_RE)
	if (!match) return { status: null, body: text }
	const status = match[1].toLowerCase() === "failure" ? "failure" : "success"
	return { status, body: text.slice(match[0].length) }
}
